module.exports = __webpack_public_path__ + "static/img/sctmIcon.25bf203b.png";